import React, { useState, useEffect } from 'react';
import './Hs.css';
import axios from '../Axiosinstance'
import { logoImage } from '../common';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBook,
  faCalendar,
  faGraduationCap,
  faCog,
  faQuestionCircle,
  faFolder,
  faUser,
  faComment,
  faDesktop,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const FeedbackModal = ({ batchId, studentIds, isOpen, onClose, batch, studentId, updateTotalCount }) => {
  const [data, setData] = useState([]);
  const [curicullumdata, setCuricullumdata] = useState([]);

  const [combinedData, setCombinedData] = useState([]);


  useEffect(() => {
    if (isOpen) {
      const fetchData = async () => {
        try {
          // Fetch both APIs in parallel
          const [generalFeedbackResponse, curriculumFeedbackResponse] = await Promise.all([
            axios.get(`generalfeedbackcreate/findByBatchAndStudentId/${batchId}/${studentIds}`),
            axios.get(`/get-curriculum-feedbacks-bybatchid-and-studentid/${batchId}/${studentIds}`)
          ]);

          console.log('General Feedback Data:', generalFeedbackResponse.data);
          console.log('Curriculum Feedback Data:', curriculumFeedbackResponse.data);

          // Filter data with status = false
          const filteredGeneralData = generalFeedbackResponse.data.filter(item => item.status === false);
          const filteredCurriculumData = curriculumFeedbackResponse.data.filter(item => item.status === false);

          // Combine the filtered data
          const combinedData = [...filteredGeneralData, ...filteredCurriculumData];

          // Update state
          setData(filteredGeneralData);
          setCuricullumdata(filteredCurriculumData);
          setCombinedData(combinedData); // Set combined data
          // setTotalCount(filteredGeneralData+filteredCurriculumData.length); // Update count based on general feedback
        } catch (err) {
          console.error('Error Fetching Data:', err);
          setData([]); // Reset data on error
          setCuricullumdata([]); // Reset curriculum data on error
        }
      };

      fetchData();
    }
  }, [isOpen, batch, studentId]);


  const handleUpdateStatus = (id, batchId, studentId, currentStatus) => {
    const newStatus = !currentStatus;

    axios.put(`generalfeedbackcreate/${id}/batch/${batchId}/student/${studentId}/status/${newStatus}`)
      .then(response => {
        console.log('Status updated successfully:', response.data);
        // Optionally refresh data or update local state
        updateTotalCount();
        onClose();
      })
      .catch(err => {
        console.error('Error updating status:', err);
      });
  };

  const handleCuricullumUpdateStatus = (id, courseId, studentId, currentStatus) => {
    const newStatus = !currentStatus;
    console.log(`Updating status with URL: update-feedback-seen-status/${id}/${courseId}/${studentId}/${newStatus}`);
    axios.put(`update-feedback-seen-status/${id}/${courseId}/${studentId}/${newStatus}`)
      .then(response => {
        console.log('Status updated successfully:', response.data);
        updateTotalCount();
        onClose();
        // Optionally refresh data or update local state
      })
      .catch(err => {
        console.error('Error updating status:', err);
      });
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Notification</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {combinedData.length > 0 ? (
          combinedData.slice().reverse().map(item => (
            <div key={item.id} style={{ marginBottom: '10px' }}>
              {item.sectionName ? ( // Check if it's a curriculum item
                <div className="d-flex justify-content-between align-items-center">
                  <strong>You have received a new Curriculum for:{item.sectionName}</strong>
                  <Button
                    variant={item.status ? 'warning' : 'success'}
                    onClick={() => handleCuricullumUpdateStatus(item.id, item.courseId, item.studentId, item.status)}
                    style={{ minWidth: '90px' }}
                  >
                    Mark as seen
                  </Button>
                </div>
              ) : ( // Handle feedback item

                <div className="d-flex justify-content-between align-items-center">
                  <strong>You have received a new feedback form. Please provide your Valuable feedback</strong><br />
                  <Button
                    variant={item.status ? 'warning' : 'success'}
                    onClick={() => handleUpdateStatus(item.id, item.batchId, item.studentId, item.status)}
                    style={{ minWidth: '90px' }}
                  >
                    Mark as seen
                  </Button>
                </div>

              )}
              <hr />
            </div>
          ))
        ) : (
          <p>No New Notifications.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" style={{ backgroundColor: 'red', minWidth: '90px' }} onClick={onClose} >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};



function App({ batch, studentId, showNotifications = true }) {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isHelpOpen, setHelpOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const studentTeacherId = localStorage.getItem('studentteacherid');
  const [registrationId, setRegistrationId] = useState(null);
  const [isRegistrationIdFetched, setIsRegistrationIdFetched] = useState(false);
  const [batchId, setBatchId] = useState(null);
  const [batchData, setBatchData] = useState([]);
  const [studentIds, setStudentIds] = useState(null);


  useEffect(() => {
    const fetchRegistrationId = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/registrationadvances/student/${studentTeacherId}`);
        if (response.data) {
          setRegistrationId(response.data.registration_id);
          setIsRegistrationIdFetched(true);
        }
      } catch (error) {
        console.error('Error fetching registration ID:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (studentTeacherId) {
      fetchRegistrationId();
    }
  }, [studentTeacherId]);

  useEffect(() => {
    if (!isRegistrationIdFetched || !registrationId) return;

    const fetchBatchIds = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/registrationadvances/student/${studentTeacherId}/registration-advances`);
        const batchData = response.data;
        setBatchId(batchData[0].batch.id);
        setStudentIds(batchData[0].student.id);
        // console.log('Batch Data:', response.data);
        setBatchData(batchData);
      } catch (error) {
        console.error('Error fetching batch data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBatchIds();
  }, [isRegistrationIdFetched, registrationId]);




  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1200);
    };

    checkScreenSize(); // Run on mount
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);




  const toggleAccount = () => {
    setAccountOpen(!isAccountOpen);
    setResourcesOpen(false);
    setHelpOpen(false); // Close resources and help dropdowns when opening account dropdown
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  const navigate = useNavigate();
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);
  const handleLogout = () => {
    // Remove user data from local storage
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    document.title = "LMS-impluz";

    // Navigate to the login page
    navigate("/login");
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data;
            localStorage.setItem("studentteacherid", data.sfid);
            document.title = `impluz - ${data.username}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url)

              .catch((studentError) => {
                console.error(studentError);
              });
          } else {
            throw new Error("Failed to fetch sfid");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);





  const fetchData = async () => {
    const bId = batch || batchId;
    const sId = studentId || studentIds;
    // console.log('Batch ID:', batch);
    // console.log('Student ID:', studentId);
    // console.log('batchId ID:', batchId);
    // console.log('studentIds ID:', studentIds);

    if (bId && sId) {
      try {
        const [generalFeedbackResponse, curriculumFeedbackResponse] = await Promise.all([
          axios.get(`generalfeedbackcreate/findByBatchAndStudentId/${bId}/${sId}`),
          axios.get(`/get-curriculum-feedbacks-bybatchid-and-studentid/${bId}/${sId}`)
        ]);

        const generalData = generalFeedbackResponse.data.filter(item => item.status === false);
        const curriculumData = curriculumFeedbackResponse.data.filter(item => item.status === false);

        const totalCount = generalData.length + curriculumData.length;
        console.log('Updated Total Count:', totalCount);
        setTotalCount(totalCount);
      } catch (err) {
        console.error('Error Fetching Data:', err);
      }
    }
  };


  useEffect(() => {
    fetchData();
  }, [batch, studentId, batchId, studentIds]);


  // Function to update the total count after status change
  const updateTotalCount = () => {
    fetchData(); // Call the same function to refresh the data
  };






  const notificationCountStyle = {
    backgroundColor: 'red', // Background color
    color: 'white', // Text color
    borderRadius: '50%', // Rounded shape
    padding: '0 5px', // Horizontal padding
    fontSize: '12px', // Font size
    verticalAlign: 'super', // Align text to the top
    marginLeft: '5px', // Space between notification text and count
    display: 'inline-block' // Ensure it is not hidden
  };

  const capitalizeFirstAndLast = (name) => {
    if (!name) return '';
    const words = name.trim().split(' ');
    if (words.length === 1) {
      // Only one word (e.g., "john")
      return words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    }

    // Capitalize first and last word, keep middle words as is
    const first = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    const lastIndex = words.length - 1;
    const last = words[lastIndex].charAt(0).toUpperCase() + words[lastIndex].slice(1).toLowerCase();

    // Reconstruct the name
    const middle = words.slice(1, lastIndex).join(' ');
    return [first, middle, last].filter(Boolean).join(' ');
  };

  const handleBack = () => {
    navigate(-1);  // Goes back to the previous page in history
  };

  return (
    <div className={`App ${isNavOpen ? 'opened' : ''}`}>

      <nav>
        <div className="logo">
          <img
            src={logoImage}
            alt="logoImage"
            style={{ width: '180px', height: '60px', }}
          />        </div>
        <button className="btn-hamburger" onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`}>
          <li className="nav-item">
            <Link to="/Dashboard">
              <FontAwesomeIcon icon={faHome} /> Home
            </Link>
          </li>

          {/* <li className="nav-item"><a href="/StudentCourese"><FontAwesomeIcon icon={faHome} /> Courses </a></li> */}
          {/* <li className="nav-item"><a href="/MyCourses"><FontAwesomeIcon icon={faHome} /> My Courses </a></li> */}

          {showNotifications && (
            <li className="nav-item" onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer', marginLeft: '20px' }}>
              <NotificationsIcon />
              <span style={{ fontSize: '18px' }}>Notification</span> {totalCount > 0 && (
                <span style={notificationCountStyle}>{totalCount}</span>
              )}
            </li>
          )}

          <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
            <Link to={''} onClick={toggleAccount}>{profileUrl ? (
              <img
                src={profileUrl}
                alt="Profile"
                style={{ marginLeft: '5px', borderRadius: '50%', width: '50px', height: '50px' }}
              />
            ) : (
              <FontAwesomeIcon icon={faUser} />
            )}    {capitalizeFirstAndLast(studentName)}</Link>
            <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`}>
              <Link className="dropdown-item" to={'/Profilestu'}>Profile</Link>
              <Link className="dropdown-item" to={'/studentchat'}>Contact us</Link>
              <Link onClick={handleLogout} className="dropdown-item" to={'/'}><FontAwesomeIcon icon={faSignOutAlt} /> Log out</Link>
            </div>
          </li>
        </ul>
      </nav>


      <div className="container">

        <FeedbackModal studentIds={studentIds} batchId={batchId} batch={batch} studentId={studentId} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} updateTotalCount={updateTotalCount} />


      </div>
      {!isMobile && location.pathname !== "/Dashboard" && (
        <Button
          style={{ backgroundColor: '#1565C0' }}
          sx={{
            // backgroundColor: '#000000',
            color: 'white',
            borderRadius: '10px',
            padding: '8px 16px',
            minWidth: '80px',
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            '&:hover': { backgroundColor: '#0056b3' }
          }}
          onClick={handleBack}
        >
          <ArrowBackIcon />
        </Button>
      )}


    </div>
  );
}



export default App;
